module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_49.6feb53e2.png";